export type FileValidationType = {
  types?: string[];
  maxSize?: number; // Megabytes
}

export const bytesToMegabytes = (bytes: number): number => bytes / (1024 * 1024);

export const checkFileValidation = (file: File, validation: FileValidationType): {valid: boolean, errors: string[] | null} => {
  const {types, maxSize} = validation;
  let valid = true;
  const errors = [] as string[];
  if (types && types.length > 0) {
    const isFormatValid = types.map(format => format.toLowerCase()).includes(file.type.replace('image/', '').toLowerCase());
    valid = valid && isFormatValid;
    const moreTypes = types.length > 0;
    const s = moreTypes ? 's' : '';
    !isFormatValid && errors.push(`Seul${s} le${s} format${s} ${types.join(', ')} ${moreTypes ? 'sont' : 'est'} accepté${s}`)
  }
  if (maxSize) {
    const isSizeValid = bytesToMegabytes(file.size) <= maxSize;
    valid = valid && isSizeValid;
    !isSizeValid && errors.push("Le fichier est trop grand. Taille maximale acceptée: " + maxSize + 'Mo');
  }
  return {valid, errors: errors.length > 0 ? errors : null}
}
